import { GetUserResponse, useUtxUsersGetUser } from '@utx/utx-client';
import React, { createContext } from 'react';
import { useStore } from 'store/store';

export const UserContext = createContext<{
  user: GetUserResponse | undefined;
  loading: boolean;
  refresh: () => void;
}>({
  user: undefined,
  loading: true,
  refresh: () => {}
});

export const UserContextProvider: React.FC = (props) => {
  const store = useStore();
  const getUserQuery = useUtxUsersGetUser({
    query: {
      onSuccess: (data) => {
        store.changeUsers(data.data);
        return data.data;
      }
    }
  });

  const { children } = props;

  return (
    <UserContext.Provider
      value={{
        loading: getUserQuery.isLoading,
        user: getUserQuery.data?.data,
        refresh: getUserQuery.refetch
      }}>
      {children}
    </UserContext.Provider>
  );
};
